import $ from 'jquery';
import stickybits from 'stickybits';


/* Global variables
********************************************/

const pageHeaderHeight = $( '.c-page-header' ).outerHeight( true );



/* Site navigation
********************************************/

$('.js-main-menu-toggle').on('click', function (e) {
	e.preventDefault();
	// $('body').toggleClass('c-offcanvas--open');
	$(this).closest('.c-page-header').toggleClass('has-menu-open');
	$('.js-main-menu-toggle').toggleClass('is-active');
	$('.js-main-menu').toggleClass('is-active');
});
// Close navigation when hit escape key
$('body').on("keydown", function (e) {
	if (e.keyCode == "27") {
		// $('body').removeClass('c-offcanvas--open');
		$('.c-page-header').removeClass('has-menu-open')
		$('.js-main-menu-toggle').removeClass('is-active');
		$('.js-main-menu').removeClass('is-active');
	}
});
// Close navigation when click outside
$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-main-menu-toggle, .c-page-header').length) {
		// $('body').removeClass('c-offcanvas--open');
		$('.c-page-header').removeClass('has-menu-open');
		$('.js-main-menu-toggle').removeClass('is-active');
		$('.js-main-menu').removeClass('is-active');
	}
});



/* User popup
********************************************/

$('.js-dropdown-popup').on('click', function (e) {
	e.preventDefault();
	$(this).closest('.c-page-header__dropdown-wrapper').toggleClass('is-open');
});
// Close dropdown when click outside
$(document).on('click', function (e) {
	if (!$(e.target).closest('.c-page-header__dropdown-wrapper').length) {
		$('.c-page-header__dropdown-wrapper').removeClass('is-open');
	}
});



/* Sticky header
********************************************/

stickybits( '.js-sticky-header', {
	useStickyClasses: true,
	//useFixed: true,
	//stickyBitStickyOffset: - pageHeaderHeight - 20,
	//customStickyChangeNumber: 10
} );

stickybits( '.js-sticky-mobile-header', {
	useStickyClasses: true,
	//useFixed: true,
	//stickyBitStickyOffset: 100,
	customStickyChangeNumber: 200
} );
